import { Form, InputNumber, DatePicker, Input, Button, Row, Col, Tabs, message, Modal } from 'antd';
import { useState, useEffect, useRef, forwardRef, useImperativeHandle }  from 'react';
import CustomSelect  from './CustomSelect.jsx';
import CustomCheckbox  from './CustomCheckbox.jsx';
import axiosInstance from './axiosInstance.js';
import moment from 'moment';
import './Form.css'
import {tabitem,handleException, getval, formitems} from './Utils.jsx'
import {rightitems} from './defs.js'
const { TabPane } = Tabs;
const { TextArea } = Input;


const FormLoan = forwardRef(({entity="TLoan", id,open,writeRight, ...props},ref)=>{
    const [form] = Form.useForm();
    const [recid, setRecid] = useState(0);
    const [loading, setLoading] = useState(true);    
    const cbFinish = useRef(null) 
    const url = '/dataservice'
    const urlsave = '/loansave'
    const items = [  
        {name:"source",       label:"Zdroj",required:true,         ctrl: (pp)=>(<CustomSelect  {...pp} disabled={true} scalar={true} url={'/loansources'} />)},
        null,
        {name:"name",         label:"Jméno",required:true,         ctrl: (pp)=>(<Input {...pp}  />)}, 
        {name:"pin",          label:"Rodné číslo",required:true,           ctrl: (pp)=>(<Input {...pp}  />)},
        {name:"mail",         label:"E-mail",required:true,        ctrl: (pp)=>(<Input {...pp}  />)},
        {name:"phone",        label:"Telefon",required:false,      ctrl: (pp)=>(<Input {...pp}  />)},
        {name:"region",       label:"Kraj",required:true,          ctrl: (pp)=>(<Input {...pp}  />)},
        {name:"income",       label:"Příjem",required:false,       ctrl: (pp)=>(<InputNumber {...pp}  />)},
        {name:"housingType",  label:"Typ bydlení",required:true,   ctrl: (pp)=>(<Input {...pp}  />)},
        {name:"insolvency_execution",  label:"Insolvence/Exekuce",required:true,   ctrl: (pp)=>(<Input {...pp}  />)},
        {name:"assigndt",     label:"Dat. přiřazení",required:false,ctrl: (pp)=>(<DatePicker {...pp} format={'DD.MM.YYYY'}/>)},
        {name:"lender",       label:"Půjčující",required:false,    ctrl: (pp)=>(<CustomSelect  {...pp} url={url} postData={{entity:'VUser', cmd:'get-items'}}/>)},
        //{name:"done",         label:"Dokončeno",required:false,    ctrl: (pp)=>(<CustomCheckbox  {...pp} disabled={true} />)},
        //{name:"removed",      label:"Odstraněno",required:false,   ctrl: (pp)=>(<CustomCheckbox  {...pp} disabled={true} />)},
        //{name:"note",         label:"Poznámky",required:false, labelCol:4,span:24,wrapperCol:20,     ctrl: (pp)=>(<TextArea {...pp}  />)}, 
        //null
    ]


    useImperativeHandle(ref, () => ({
        open(id,cb=null) { if(id) loadData(id); else handleNew(); cbFinish.current = cb }
    }))
        

    function translate(r,dir){
        if(!r) return r;
        if(dir == 0) {
            r.assigndt = r.assigndt ? moment(r.assigndt):r.assigndt  
        } else { 
            r.assigndt = r.assigndt ? r.assigndt.valueOf():r.assigndt
        }
        return r      
    }


    async function loadData(recid) { 
		setRecid(recid)
        setLoading(true);	
        try {
			let response = await axiosInstance.post(url, {cmd:'get-record',entity:entity,recid:recid});
            var r = response.data.record
            console.log('lender',r)
            r = translate(r,0)  
            form.setFieldsValue(r);        
		} catch (err) {  
            handleException(err)
		} finally {
			setLoading(false);
		}
	};

    async function saveData() {
		setLoading(true);
		try {
			const response = await axiosInstance.post(urlsave, {recid:recid, ...translate(form.getFieldsValue(),1)});
            message.success('Záznam byl úspěšně uložen');
            console.log(response)
		} catch (err) {
            handleException(err)
		} finally {
			setLoading(false);
		}
	};

    function handleChange(changedValues, allValues) { 
        //console.log('allvalues',allValues)
        console.log('changedvalues',changedValues)          
    };

    function handleNew(){
        setRecid(0)
        form.resetFields()
        form.setFieldsValue({source:'0'}) 
    };

    function handleCopy(){
        setRecid(0) 
        form.setFieldsValue({source:'0',assigndt:null,lender:null}) 
    };

    async function handleFinish(values){
        console.log('Form Values:', values);
        await saveData();
        if(cbFinish.current) cbFinish.current(values);
    };
    
    return (
        <div>
        <Form
            form={form}
            name={'loanForm'}
            labelCol={{ span: 9 }}
            onFinish={handleFinish}
            onValuesChange={handleChange}
            disabled={!writeRight}
        >           
            {formitems(items,{},{},2)}
            
            <Form.Item wrapperCol={{ offset: 10, span: 24 }}>
                <Button type="primary" htmlType="submit">Uložit</Button>
                <Button onClick={handleNew} style={{ marginLeft: '10px' }}>Nový</Button>
                <Button onClick={handleCopy} style={{ marginLeft: '10px' }}>Kopie</Button>
            </Form.Item>
        </Form>
        </div>
    )
})

export default FormLoan;





